import { useEffect } from 'react';

export const useTitle = (title?: string) => {
  useEffect(() => {
    if (title && title !== 'undefined') {
      document.title = title;
    }
  }, [title]);
};